import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";

export default function EasyShareDirection() {
  const eventId = new URLSearchParams(useLocation().search).get("event_id");
  const clusterId = new URLSearchParams(useLocation().search).get("cluster_id");

  const iosDeepLink = "https://apps.apple.com/in/app/jiophotos/id6450602471";
  const androidDeepLink = `https://play.google.com/store/apps/details?id=com.jio.photos&referrer=${eventId},${clusterId}`;

  useEffect(() => {
    console.log("hello==>", androidDeepLink);

    // NEW
    const os = getOS();
    if (os == "iOS") {
      window.location.href = iosDeepLink;
    } else if (os == "Android Phone") {
      window.location.href = androidDeepLink;
    } else {
      //   setShowCard(true);
      //   getData();
    }
  }, []);

  const getOS = () => {
    const userAgent = navigator.userAgent || window.opera;

    // iOS detection
    if (/iPhone/.test(userAgent)) {
      return "iOS";
    }

    // macOS detection
    if (/Macintosh/.test(userAgent) && !("ontouchend" in document)) {
      return "macOS";
    }

    // Android detection
    if (/android/i.test(userAgent)) {
      // Further check if it's a tablet
      const isTablet = /tablet|ipad/i.test(userAgent);
      return isTablet ? "Android Tablet" : "Android Phone";
    }

    // Default to unknown if none matches
    return "unknown";
  };
  return <div>EasyShareDirection</div>;
}
